import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles: ReturnType<typeof styled> = styled('div', {
  '.resultsCount': {
    paddingTop: 'var(--abyss-space-xs)',
  },
});
